
import BranchMap from "~/components/branch_offices/BranchMap";
import { normalizeBranches, normalizeClusters, directionsUrl } from "~/utils/branch-offices";
import { fetchBranchOffices } from "~/utils/branch-office-loader";

export default {
    spacingDebug: false,
    components: { BranchMap },
    props: {
        branches: { type: Array, default: () => [] },
        clusters: { type: Array, default: () => [] },
        title: { type: String, default: "Branch offices" },
    },
    data() {
        const clusters = normalizeClusters(this.clusters);
        return {
            branchRows: this.branches,
            clusterRows: this.clusters,
            loading: false,
            loadError: false,
            requestVersion: 0,
            keyword: "",
            activeId: null,
            overlayWidth: 0,
            activeClusterId: (clusters.find((cluster) => cluster.active) || clusters[0])?.id || null,
        };
    },
    computed: {
        normalizedClusters() {
            return normalizeClusters(this.clusterRows);
        },
        activeCluster() {
            return this.normalizedClusters.find((cluster) => cluster.id === this.activeClusterId) || null;
        },
        normalizedBranches() {
            return normalizeBranches(this.branchRows);
        },
        filteredBranches() {
            return this.loading || this.loadError ? [] : this.normalizedBranches;
        },
        query() {
            return JSON.stringify([this.activeClusterId, this.keyword.trim()]);
        },
        hasFilters() {
            return Boolean(this.keyword.trim());
        },
    },
    watch: {
        query(value, previous) {
            clearTimeout(this.searchTimer);
            this.requestVersion++;
            this.loading = true;
            this.loadError = false;
            this.activeId = null;
            const clusterChanged = JSON.parse(value)[0] !== JSON.parse(previous)[0];
            if (clusterChanged || !this.hasFilters) this.loadBranches();
            else this.searchTimer = setTimeout(() => this.loadBranches(), 300);
        },
        filteredBranches(branches) {
            if (!branches.some((branch) => branch.id === this.activeId)) this.activeId = null;
        },
    },
    mounted() {
        this.measurePanel = () => {
            this.overlayWidth = window.matchMedia("(width > 55rem)").matches ? this.$el.getBoundingClientRect().right - this.$refs.panel.getBoundingClientRect().left : 0;
        };
        this.measurePanel();
        window.addEventListener("resize", this.measurePanel);
        if (window.ResizeObserver) {
            this.panelObserver = new ResizeObserver(this.measurePanel);
            this.panelObserver.observe(this.$refs.panel);
        }
    },
    beforeDestroy() {
        clearTimeout(this.searchTimer);
        this.requestVersion++;
        window.removeEventListener("resize", this.measurePanel);
        if (this.panelObserver) this.panelObserver.disconnect();
    },
    methods: {
        directionsUrl,
        async loadBranches() {
            clearTimeout(this.searchTimer);
            const version = ++this.requestVersion;
            const query = this.query;
            this.loading = true;
            this.loadError = false;
            this.activeId = null;
            try {
                const content = await fetchBranchOffices(this.$axios, this.activeClusterId, this.keyword.trim());
                if (version !== this.requestVersion || query !== this.query || this._isDestroyed) return;
                this.branchRows = content.branches;
                this.clusterRows = content.clusters;
                if (this.$refs.results) this.$refs.results.scrollTop = 0;
            } catch (_) {
                if (version === this.requestVersion && query === this.query && !this._isDestroyed) this.loadError = true;
            } finally {
                if (version === this.requestVersion && query === this.query && !this._isDestroyed) this.loading = false;
            }
        },
        displayName(value) {
            return value.toLowerCase().replace(/\b\w/g, (letter) => letter.toUpperCase());
        },
        selectBranch(id) {
            if (this.activeId === id && id) this.$refs.map.focusBranch(id);
            this.activeId = id;
        },
        selectFromMap(id) {
            this.selectBranch(id);
            this.$nextTick(() => {
                const results = this.$refs.results;
                const row = document.getElementById(`c2a7c47d-5fca-4b30-9bf9-8d3e8db92aee-${id}`);
                if (row && results.scrollHeight > results.clientHeight) results.scrollTop += row.getBoundingClientRect().top - results.getBoundingClientRect().top;
            });
        },
        selectCluster(id) {
            this.activeClusterId = id;
            this.clearFilters();
            this.$nextTick(() => {
                this.$refs.map.showCluster();
                this.$refs.results.scrollTop = 0;
            });
        },
        clearFilters() {
            this.keyword = "";
            this.activeId = null;
        },
    },
};
